import * as Sentry from "@sentry/react";

const LOG_LEVELS = { DEBUG: 0, INFO: 1, WARN: 2, ERROR: 3 };

const currentLevel =
  process.env.NODE_ENV === "production"
    ? LOG_LEVELS.ERROR
    : LOG_LEVELS.DEBUG;

const isDev = process.env.NODE_ENV !== "production";

function formatMessage(level, context, message, data) {
  const timestamp = new Date().toISOString();
  return { timestamp, level, context, message, ...data };
}

const logger = {
  debug(context, message, data = {}) {
    if (isDev && currentLevel <= LOG_LEVELS.DEBUG) {
      console.log("[DEBUG]", formatMessage("DEBUG", context, message, data));
    }
  },
  info(context, message, data = {}) {
    if (isDev && currentLevel <= LOG_LEVELS.INFO) {
      console.log("[INFO]", formatMessage("INFO", context, message, data));
    }
  },
  warn(context, message, data = {}) {
    if (currentLevel <= LOG_LEVELS.WARN) {
      console.warn("[WARN]", formatMessage("WARN", context, message, data));
    }
  },
  error(context, message, data = {}) {
    if (currentLevel <= LOG_LEVELS.ERROR) {
      console.error("[ERROR]", formatMessage("ERROR", context, message, data));
    }
    Sentry.captureException(new Error(`[${context}] ${message}`), {
      extra: data,
    });
  },
};

export default logger;
export { LOG_LEVELS };
